var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileavatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 37,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4024 60.4772C57.6498 67.7017 48.0354 72.2174 37.3663 72.2174C26.1129 72.2174 16.0329 67.1935 9.24683 59.2662C9.42964 58.862 9.63985 58.4664 9.87746 58.0795C10.9079 56.4013 12.2769 55.1206 13.9846 54.2374C17.6353 52.412 21.3449 51.0429 25.1135 50.1303C28.882 49.2176 32.7094 48.7612 36.5957 48.7612C40.4819 48.7612 44.3093 49.2176 48.0779 50.1303C51.8464 51.0429 55.556 52.412 59.2068 54.2374C60.9144 55.1206 62.2834 56.4013 63.3139 58.0795C63.7839 58.845 64.1468 59.6443 64.4024 60.4772ZM26.615 41.077C29.3825 43.8445 32.7094 45.2282 36.5957 45.2282C40.4819 45.2282 43.8088 43.8445 46.5763 41.077C49.3439 38.3095 50.7276 34.9826 50.7276 31.0963C50.7276 27.21 49.3439 23.8831 46.5763 21.1156C43.8088 18.3481 40.4819 16.9644 36.5957 16.9644C32.7094 16.9644 29.3825 18.3481 26.615 21.1156C23.8475 23.8831 22.4637 27.21 22.4637 31.0963C22.4637 34.9826 23.8475 38.3095 26.615 41.077Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileavatar);
export default __webpack_public_path__ + "static/media/Profileavatar.1118a2f07c9ab4af034882268fca1384.svg";
export { ForwardRef as ReactComponent };